<template><div class="joinin-page"><div class="common-header-wrap"><mt-header title="Merchant settled" class="common-header"><mt-button slot="left" icon="back" @click="$router.go(-1)" /></mt-header></div><joinin-step :active="3" /><section class="status-card"><i class="iconfont">&#xe6a6;</i><h1>{{ title }}</h1><p>{{ message }}</p><mt-button v-if="opened" size="large" type="primary" class="joinin-button" @click="goStoreHome">Go to Store home</mt-button><mt-button v-else-if="retry" size="large" type="primary" class="joinin-button" @click="$router.replace({ name: 'HomeSellerJoinin2' })">Update application</mt-button></section></div></template>
<script>
import JoininStep from './JoininStep'
import { getJoininApplication } from '../../../api/joinin'

export default {
  components: { JoininStep },
  data () { return { state: 11, refreshTimer: null } },
  computed: {
    title () { return this.state === 40 ? 'Store opened' : this.state === 30 || this.state === 31 ? 'Review failed' : 'Under review' },
    message () { return this.state === 11 ? 'Your payment is being reviewed.' : this.state === 40 ? 'Your merchant account is ready.' : 'We will notify you after review.' },
    retry () { return this.state === 30 || this.state === 31 },
    opened () { return this.state === 40 }
  },
  created () {
    this.refreshStatus()
    this.refreshTimer = window.setInterval(this.refreshStatus, 30000)
    window.addEventListener('focus', this.refreshStatus)
  },
  beforeDestroy () {
    window.clearInterval(this.refreshTimer)
    window.removeEventListener('focus', this.refreshStatus)
  },
  methods: {
    goStoreHome () {
      this.$router.push({ name: this.$store.state.seller.isOnline ? 'SellerIndex' : 'HomeSellerLogin' })
    },
    refreshStatus () {
      getJoininApplication().then(res => {
        if (res.result.store_joinin) this.state = Number(res.result.store_joinin.joinin_state)
      }).catch(() => {})
    }
  }
}
</script>
<style scoped lang="scss">.joinin-page{min-height:100vh;background:#f6f6f6}.status-card{text-align:center;margin:.7rem;background:#fff;padding:2.5rem 1rem}.status-card i{font-size:2.5rem;color:#ff6a00}.status-card h1{font-size:1rem;color:#333}.status-card p{font-size:.7rem;color:#777}.joinin-button{margin-top:1.2rem;background:#ff6a00}</style>
